export interface CtaScreenConfig {
  buttonArrowClass?: string;
  buttonClass?: string;
  buttonText?: string;
  buttonTextClass?: string;
  colLeftClass?: string;
  colRightClass?: string;
  containerClass?: string;
  messageBoxClass?: string;
  messageText?: string;
  customTagline?: string;
}

export interface AdVideoConfig {
  element?: string | HTMLElement;
  product?: string;
  autoplay?: boolean;
  duration?: number;
  keyvalues?: string | Record<string, string>;
  adPodding?: boolean;
  type?: string;
  position?: string;
  isDev?: boolean;
  finalCallback?: () => void;
  onCTAStateChange?: (event: { isShowing: boolean }) => void;
  CTAScreenConfig?: CtaScreenConfig;
}

export interface ResolvedVideoConfig {
  readonly container: HTMLElement;
  readonly element: string;
  readonly product?: string;
  readonly autoplay: boolean;
  readonly duration: number;
  readonly keyvalues?: string | Record<string, string>;
  readonly adPodding: boolean;
  readonly type?: string;
  readonly position?: string;
  readonly isDev: boolean;
  readonly finalCallback: () => void;
  readonly onCTAStateChange: (event: { isShowing: boolean }) => void;
  readonly CTAScreenConfig: Readonly<CtaScreenConfig>;
}

export function resolveVideoConfig(
  config: AdVideoConfig,
  container: HTMLElement,
): ResolvedVideoConfig {
  const element =
    typeof config.element === "string"
      ? config.element
      : config.element?.id || container.id || "ark_pre-roll";

  return {
    container,
    element,
    product: config.product,
    autoplay: config.autoplay ?? false,
    duration: config.duration ?? 30,
    keyvalues:
      typeof config.keyvalues === "object"
        ? { ...config.keyvalues }
        : config.keyvalues,
    adPodding: config.adPodding ?? true,
    type: config.type,
    position: config.position,
    isDev: config.isDev ?? false,
    finalCallback:
      config.finalCallback ??
      (() => container.dispatchEvent(new Event("onPrerollEnd"))),
    onCTAStateChange: config.onCTAStateChange ?? (() => undefined),
    CTAScreenConfig: { ...config.CTAScreenConfig },
  };
}
